// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS scoped per BaixesEmpleat.js (Gestió d'Empleat -> pestanya Baixes).
   Mateixa estètica compacta de filtres/formularis que absenciesempleat.css,
   per coherència visual dins la mateixa Gestió d'Empleat. Fàcil de revertir:
   totes les classes són pròpies (prefix "baixes-emp-") i no toquen
   Dashboard.css. */

.baixes-emp-filtres {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  background-color: #f4f4f4;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 12px;
}

.baixes-emp-filtres label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: bold;
  color: #444;
}

.baixes-emp-filtres select,
.baixes-emp-filtres input[type="date"] {
  font-size: 13px;
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.baixes-emp-error {
  color: #b30000;
  font-weight: bold;
}

.baixes-emp-actual {
  background-color: #fff7e0;
  border: 1px solid #e8d68a;
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 14px;
}

.baixes-emp-actual-info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  font-size: 14px;
}

.baixes-emp-actual-titol {
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
  color: #8a6d1a;
}

.baixes-emp-actual-notes {
  margin-top: 6px;
  font-size: 13px;
  color: #555;
  font-style: italic;
}

.baixes-emp-sense-oberta {
  color: #888;
  font-style: italic;
  margin-bottom: 10px;
}

.baixes-emp-accions {
  margin-bottom: 12px;
}

.baixes-emp-tipus-chip {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  color: #fff;
  font-weight: bold;
}

.baixes-emp-form h4 {
  font-size: 14px;
  margin: 0 0 10px;
}

.baixes-emp-form label {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 13px;
  font-weight: bold;
}

.baixes-emp-form select,
.baixes-emp-form input[type="date"],
.baixes-emp-form textarea {
  font-size: 13px;
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.baixes-emp-form textarea {
  width: 100%;
  max-width: 500px;
  height: 50px;
  resize: vertical;
}

.baixes-emp-btn-esborrar {
  background-color: #b30000;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/baixesempleat.css"],"names":[],"mappings":"AAAA;;;;mBAImB;;AAEnB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb","sourcesContent":["/* CSS scoped per BaixesEmpleat.js (Gestió d'Empleat -> pestanya Baixes).\n   Mateixa estètica compacta de filtres/formularis que absenciesempleat.css,\n   per coherència visual dins la mateixa Gestió d'Empleat. Fàcil de revertir:\n   totes les classes són pròpies (prefix \"baixes-emp-\") i no toquen\n   Dashboard.css. */\n\n.baixes-emp-filtres {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 14px;\n  background-color: #f4f4f4;\n  border-radius: 6px;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n}\n\n.baixes-emp-filtres label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: bold;\n  color: #444;\n}\n\n.baixes-emp-filtres select,\n.baixes-emp-filtres input[type=\"date\"] {\n  font-size: 13px;\n  padding: 4px 6px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.baixes-emp-error {\n  color: #b30000;\n  font-weight: bold;\n}\n\n.baixes-emp-actual {\n  background-color: #fff7e0;\n  border: 1px solid #e8d68a;\n  border-radius: 6px;\n  padding: 10px 14px;\n  margin-bottom: 14px;\n}\n\n.baixes-emp-actual-info {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 14px;\n  font-size: 14px;\n}\n\n.baixes-emp-actual-titol {\n  font-weight: bold;\n  text-transform: uppercase;\n  font-size: 12px;\n  color: #8a6d1a;\n}\n\n.baixes-emp-actual-notes {\n  margin-top: 6px;\n  font-size: 13px;\n  color: #555;\n  font-style: italic;\n}\n\n.baixes-emp-sense-oberta {\n  color: #888;\n  font-style: italic;\n  margin-bottom: 10px;\n}\n\n.baixes-emp-accions {\n  margin-bottom: 12px;\n}\n\n.baixes-emp-tipus-chip {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 12px;\n  color: #fff;\n  font-weight: bold;\n}\n\n.baixes-emp-form h4 {\n  font-size: 14px;\n  margin: 0 0 10px;\n}\n\n.baixes-emp-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.baixes-emp-form select,\n.baixes-emp-form input[type=\"date\"],\n.baixes-emp-form textarea {\n  font-size: 13px;\n  padding: 4px 6px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.baixes-emp-form textarea {\n  width: 100%;\n  max-width: 500px;\n  height: 50px;\n  resize: vertical;\n}\n\n.baixes-emp-btn-esborrar {\n  background-color: #b30000;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
